import { Navigate, Routes, Route, Outlet } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import { useIntl } from 'react-intl'
import { ReportList } from './ReportList'

import PermissionsService from '../auth/PermissionsService';


const ReportPagePaymentService = () => {
  const intl = useIntl()
  const userBreadCrumbs: Array<PageLink> = [
    {
      title: 'Reportes',
      path: '/recharges-reports',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]

  const permissions = PermissionsService.getPermissions();
  const {
    hasConsumptionReportPaymentServicePermission,

  } = permissions || {};


  return (
    <Routes>
      <Route element={<Outlet />}>

        {hasConsumptionReportPaymentServicePermission ? (
          <Route
            path='list'
            element={
              <>
                <ReportList />
                <PageTitle breadcrumbs={userBreadCrumbs}>
                  Reportes de pago de servicios
                </PageTitle>
              </>
            }
          />
        ) : (
          <Route path='list' element={<Navigate to='/error/403' replace />} />
        )}

      </Route>

      <Route index element={<Navigate to='list' />} />

    </Routes>
  )
}

export default ReportPagePaymentService
